export const DEFAULT_MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB

/** 1024-based B / KB / MB string for limits (matches common OS / Finder-style steps). */
export const KB = 1024;
export const MB = KB * KB;

/**
 * Non-canonical extension spellings → preferred canonical form (single key per family).
 * Example: `jpeg` and `jpg` both normalize to `jpg` for allow-list checks.
 */
export const extensionAliasToCanonical: Readonly<Record<string, string>> = {
  jpeg: 'jpg',
  jpe: 'jpg',
  jfif: 'jpg',
  tif: 'tiff',
  htm: 'html',
};

/**
 * For each canonical extension, every suffix we put on `accept=` so OS pickers match the same family.
 * Canonicals not listed here use `[canonical]` only.
 */
export const canonicalToAcceptExtensions: Readonly<Record<string, readonly string[]>> = {
  jpg: ['jpg', 'jpeg', 'jpe', 'jfif'],
  tiff: ['tif', 'tiff'],
  html: ['htm', 'html'],
};

/**
 * Non-canonical MIME spellings → preferred canonical form for comparisons.
 */
export const mimeAliasToCanonical: Readonly<Record<string, string>> = {
  'application/x-zip-compressed': 'application/zip',
  'image/jpg': 'image/jpeg',
  'image/pjpeg': 'image/jpeg',
  'application/csv': 'text/csv',
  'text/comma-separated-values': 'text/csv',
};

/**
 * Canonical extension → MIME types browsers may report for `File.type` (canonical MIMEs only).
 * Unlisted canonical extensions still work via extension match alone.
 */
export const extensionToMimeTypes: Readonly<Record<string, readonly string[]>> = {
  pdf: ['application/pdf'],
  jpg: ['image/jpeg'],
  png: ['image/png'],
  gif: ['image/gif'],
  webp: ['image/webp'],
  svg: ['image/svg+xml'],
  zip: ['application/zip'],
  json: ['application/json'],
  doc: ['application/msword'],
  docx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  xls: ['application/vnd.ms-excel'],
  xlsx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  csv: ['text/csv'],
  txt: ['text/plain'],
  html: ['text/html'],
  tiff: ['image/tiff'],
};
